



















































































import {Component, Emit, Prop} from "vue-property-decorator";
import abpbase from "../../lib/abpbase";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import {paginationElement} from "@/api/typeDefined";
import AppConsts from "@/lib/appconst";

@Component({
    name: 'QATab',
    filters: {
        imgUrlFilter(url: string = '') {
            if (url && url.indexOf('http') > -1) {
                return url;
            } else {
                let fileResourceUrl: string = AppConsts.fileResourceUrl;
                return `${fileResourceUrl}${url}`;
            }
        }
    }
})
export default class QATab extends abpbase {
    // @Prop({type: String, default: ''}) keywords: string;
    keywords: string = '';

    tabList: object = [
        {key: 'all', tab: '全部问题'},
        {key: 'myQuestions', tab: '我的提问'},
        {key: 'myAnswer', tab: '我的回答'}
    ];

    tabKey: string = 'all';

    allRecords: any = {};
    moduleType: string = '2';

    //分页
    pagination: paginationElement = {
        ...AppConsts.pagination,
        onShowSizeChange: (pageIndex, size) => {
            this.pagination.current = pageIndex;
            this.pagination.pageSize = size;
            this.fetchRecords();
        },
        onChange: pageIndex => {
            this.pagination.current = pageIndex;
            this.fetchRecords();
        }
    };

    //初始化分页参数
    initPagination() {
        this.pagination = {
            ...AppConsts.pagination,
            onShowSizeChange: (pageIndex, size) => {
                this.pagination.current = pageIndex;
                this.pagination.pageSize = size;
                this.fetchRecords();
            },
            onChange: pageIndex => {
                this.pagination.current = pageIndex;
                this.fetchRecords();
            }
        };
    }

    //获取数据
    fetchRecords(tabName: string = this.tabKey) {
        let {current, pageSize} = this.pagination;
        let queryParams = {
            currentPage: current,
            pageSize: pageSize,
            // moduleType: '2',//模块: 1: 知识库; 2: Q&A; 空: 全部
            keyWords: this.keywords
        };

        let url: string = '/web/global/query';

        switch (tabName) {
            //我的提问
            case 'myQuestions':
                url = '/web/user/question';
                break;
            //我的回答
            case 'myAnswer':
                url = '/web/user/answer';
                break;
            //全部
            default:
                //模块: 1: 知识库; 2: Q&A; 空: 全部
                queryParams = {...queryParams, ...{moduleType: '2'}};
                break;
        }

        ajaxHelperInstance.get(url, queryParams, undefined, this).then((res) => {
            let {status, data} = res;
            if (status === 200) {
                this.allRecords = data.data || [];
                this.pagination.total = 0;
                if (data) {
                    let {page} = data;
                    if (page) {
                        this.pagination.total = page.total;
                    }
                }
            }
        });
    }

    //tab切换
    handleChangeTab(key: string) {
        this.tabKey = key;
        this.initPagination();
        this.fetchRecords();
    }

    //显示
    show(keywords: string = '') {
        this.keywords = keywords;
        this.initPagination();
        this.fetchRecords();
    }

    //我要提问
    @Emit('askQuestion')
    handleAskQuestion() {
    }

    //显示详情
    handleShowDetail(questionId: string) {
        this.switchRouting('QADetail', {
            queryParams: JSON.stringify({
                keywords: this.keywords,
                questionId: questionId,
                skip: false
            })
        });
    }

    mounted() {
        this.show();
    }
}
